import { Link, useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";

const WhatsAppIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.91-7.01zM12.04 20.15h-.01a8.23 8.23 0 0 1-4.19-1.15l-.3-.18-3.11.82.83-3.04-.2-.31a8.18 8.18 0 0 1-1.26-4.37c0-4.54 3.69-8.23 8.24-8.23 2.2 0 4.27.86 5.82 2.42a8.19 8.19 0 0 1 2.41 5.82c-.01 4.54-3.7 8.22-8.23 8.22zm4.51-6.16c-.25-.12-1.47-.72-1.69-.81-.23-.08-.39-.12-.56.13-.16.25-.64.81-.79.97-.14.17-.29.19-.54.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.12-.14.16-.25.25-.41.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.76-1.84-.2-.48-.41-.42-.56-.42h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.05 0 1.21.88 2.38 1 2.54.12.17 1.74 2.66 4.21 3.73.59.25 1.05.41 1.41.52.59.19 1.13.16 1.55.1.47-.07 1.47-.6 1.67-1.18.21-.58.21-1.07.14-1.18-.06-.11-.22-.17-.47-.29z"/>
  </svg>
);

export const Header = () => {
  const navigate = useNavigate();
  return (
    <header className="glass-header sticky top-0 z-40" data-testid="main-header">
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 group" data-testid="home-logo">
          <div className="w-9 h-9 rounded-md bg-[#FFC107] flex items-center justify-center group-hover:rotate-12 transition-transform duration-200">
            <KeyRound className="w-5 h-5 text-black" strokeWidth={2.5} />
          </div>
          <div className="flex flex-col leading-tight">
            <span className="font-display font-bold text-lg text-white tracking-tight">SasCerrajería</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-[#71717A] font-mono">Automoción · 24/7</span>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-[#A1A1AA]">
          <a href="/#servicios" className="hover:text-white transition-colors" data-testid="nav-services">Servicios</a>
          <a href="/#como-funciona" className="hover:text-white transition-colors" data-testid="nav-how">Cómo funciona</a>
          <a href="/#contacto" className="hover:text-white transition-colors" data-testid="nav-contact">Contacto</a>
        </nav>
        <div className="flex items-center gap-3">
          <a
            href="https://wa.me/34641719027"
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:flex items-center gap-2 text-sm text-white hover:text-[#25D366] transition-colors"
            data-testid="whatsapp-cta"
          >
            <WhatsAppIcon className="w-4 h-4 text-[#25D366]" /> 641 719 027
          </a>
          <button
            onClick={() => navigate("/reservar")}
            className="btn-amber px-4 py-2 rounded-md font-medium text-sm"
            data-testid="header-book-btn"
          >
            Reservar ahora
          </button>
        </div>
      </div>
    </header>
  );
};
